import { Grid } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import EContent from "./e_content/e_content";
import SearchBar from "./e_search_bar/e_search_bar";
import { Tab, Tabs } from "@material-ui/core";
import E_Announcements from "./e_announcements/e_announcements";
import E_Faqs from "./e_faqs/e_faqs";
import { useSelector } from "react-redux";
import { useRef } from "react";
import E_Links from "./e_useful-links/e_useful_links";
import axios from "axios";
import { config } from "../../../enviroment";
import SearchNoResult from "./e_search_bar/view/_search_no_result";
import { Skeleton } from "@material-ui/lab";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  contentContainer: {
    backgroundColor: theme.palette.eWhite.base + "e6",
    borderRadius: 6,
    height: "100%",
    padding: "1rem",
    position: "relative"
  },
  smContentContainer: {
    marginTop: "10%",
    width: "90% !important",
    margin: "auto",
    background: theme.palette.eWhite.base,
    borderRadius: 6,
  },
  tabStyles: {
    minWidth: "20%",
    minHeight: "40px",
    fontWeight: "light",
    transition: "0.5s ease-in-out",
    borderRadius: " 4px 4px 0 0",
    textTransform: "none",
  },
  selectedTab: {
    background: theme.palette.eTertiary.base + "!important",
    color: theme?.palette?.eWhite?.base + " !important",
  },
  unSelctedTab: {
    background: "none",
    color: theme?.palette?.eRich?.base + " !important",
    "&:hover": {
      background: theme.palette.eTertiary.hover + "!important",
      color: theme?.palette?.eWhite?.base + " !important",
    },
  },
  baseTabStyles: {
    borderBottom: "2px solid " + theme.palette.eSecondary.base,
    minHeight: "30px",
  },
  marginTopSearch: {
    marginTop: "6%",
  },
}));
function EContentSection(props) {
  const containerRef = useRef(null);
  const classes = useStyles();
  const [height, setHeight] = useState(600);
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 640px)" });
  const [selectedTab, setSelectedTab] = useState(0);
  const [keyWord, setKeyword] = useState();
  const [searchResult, setSearchResult] = useState();
  const [noData, setNoData] = useState(false);
  const [searchFAQData, setsearchFAQData] = useState();
  const [searchLinksData, setsearchLinksData] = useState();
  const [searchAnnData, setsearchAnnData] = useState();
  const [loading, setLoading] = useState(false);
  const [totalSearch, setTotalSearch] = useState();

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  useEffect(() => {
    if (props?.tab === "FAQ") {
      if (isTabletOrMobile) {
        scrollTo("faqs");
      }
      setSelectedTab(1);
    }
  }, [props?.tab]);

  const callSearchApi = (keyWord) => {
    setLoading(true);
    setKeyword(keyWord);
    // let finalWord = keyWord.toLowerCase().startsWith("faq")
    //   ? "FAQ_AUTH"
    //   : keyWord.toLowerCase().startsWith("link")
    //     ? "LINKS_AUTH"
    //     : keyWord;
    // axios
    //   .post(config.urls.SEARCH, {
    //     size: 50,
    //     query: {
    //       multi_match: {
    //         query: `*${finalWord}*`,
    //         fuzziness: "AUTO",
    //         fields: ["ContentTitle", "ContentCategoryCode", "ContentValue"],
    //       },
    //     },
    //   })
    axios
      .post(config.urls.SEARCH,{keyWord:keyWord,indexName:"adss_auth_database"})
      .then((res) => {
        setLoading(false);
        setSearchResult(res?.data);
      })
      .catch((error) => {
        setLoading(false);
        setsearchAnnData([]);
        setsearchFAQData([]);
        setsearchLinksData([]);
      });
  };

  useEffect(() => {
    if (keyWord) {
      setTotalSearch(
        searchAnnData?.length + searchFAQData?.length + searchLinksData?.length
      );
    } else {
      setTotalSearch();
    }
  }, [searchAnnData, searchFAQData, searchLinksData]);

  const scrollTo = (id) => {
    let scrollDiv = document.getElementById(id);
    if (scrollDiv)
      window.scrollTo({ top: scrollDiv.offsetTop - 15, behavior: "smooth" });
  };

  useEffect(() => {
    if (keyWord) {
      if (searchResult?.hits?.total?.value) {
        setNoData(false);
        setsearchFAQData(
          searchResult?.hits?.hits?.filter(
            (item) => item?._source?.ContentCategoryCode === "FAQ_AUTH"
          )
        );

        setsearchLinksData(
          searchResult?.hits?.hits?.filter(
            (item) => item?._source?.ContentCategoryCode === "LINKS_AUTH"
          )
        );

        setsearchAnnData(
          searchResult?.hits?.hits?.filter(
            (item) => item?._source?.ContentCategoryCode === "ANNOUNCEMENT_AUTH"
          )
        );
      } else {
        setNoData(true);
        setsearchFAQData([]);
        setsearchAnnData([]);
        setsearchLinksData([]);
      }
    }
  }, [searchResult, keyWord]);

  const getDefaultSearch = () => {
    setSearchResult();
    setsearchAnnData();
    setsearchFAQData();
    setsearchLinksData();
    setKeyword();
    setSelectedTab(0);
    setTotalSearch();
    setNoData(false)
  };

  useEffect(() => {
    if (keyWord) {
      if (searchFAQData?.length > 0) {
        setSelectedTab(0);
      } else if (searchAnnData?.length > 0) {
        setSelectedTab(1);
      } else if (searchLinksData?.length > 0) {
        setSelectedTab(2);
      }
    }
  }, [searchAnnData, searchFAQData, searchLinksData, keyWord]);

  return (
    <>
      {isTabletOrMobile ? (
        <React.Fragment>
          <Grid
            container
            className={classes.smContentContainer}
            justify="center"
          >
            <Grid item className={classes.marginTopSearch} xs={11}>
              <SearchBar
                callSearchApi={callSearchApi}
                totalSearch={totalSearch}
                getDefaultSearch={getDefaultSearch}
              />
            </Grid>
            {!keyWord && (
              <Grid item style={{ width: "-webkit-fill-available" }}>
                <EContent scrollTo={scrollTo} />
              </Grid>
            )}
            {searchFAQData?.length === 0 &&
              searchAnnData?.length === 0 &&
              searchLinksData?.length === 0 && <SearchNoResult />}
          </Grid>

          {keyWord && loading === true ? (
            <Skeleton variant="text"></Skeleton>
          ) : (
            !noData &&
            !loading && (
              <>
                {!keyWord ? (
                  <Grid
                    id="faqs"
                    container
                    className={classes.smContentContainer}
                  >
                    <Grid item style={{ width: "-webkit-fill-available" }}>
                      <E_Faqs keyWord={keyWord} searchFAQData={searchFAQData} />
                    </Grid>
                  </Grid>
                ) : (
                  searchFAQData &&
                  searchFAQData.length > 0 && (
                    <Grid
                      id="faqs"
                      container
                      className={classes.smContentContainer}
                    >
                      <Grid item style={{ width: "-webkit-fill-available" }}>
                        <E_Faqs
                          keyWord={keyWord}
                          searchFAQData={searchFAQData}
                        />
                      </Grid>
                    </Grid>
                  )
                )}

                {!noData && !loading && (
                  <>
                    {!keyWord ? (
                      <Grid
                        id="announcements"
                        container
                        className={classes.smContentContainer}
                      >
                        <Grid item style={{ width: "-webkit-fill-available" }}>
                          <E_Announcements />
                        </Grid>
                      </Grid>
                    ) : (
                      searchAnnData &&
                      searchAnnData.length > 0 && (
                        <Grid
                          id="announcements"
                          container
                          className={classes.smContentContainer}
                        >
                          <Grid
                            item
                            style={{ width: "-webkit-fill-available" }}
                          >
                            <E_Announcements
                              keyWord={keyWord}
                              searchAnnData={searchAnnData}
                            />
                          </Grid>
                        </Grid>
                      )
                    )}
                  </>
                )}
                {!noData && !loading && (
                  <>
                    {!keyWord ? (
                      <Grid
                        id="links"
                        container
                        className={classes.smContentContainer}
                      >
                        <Grid item style={{ width: "-webkit-fill-available" }}>
                          <E_Links />
                        </Grid>
                      </Grid>
                    ) : (
                      searchLinksData &&
                      searchLinksData.length > 0 && (
                        <Grid
                          id="links"
                          container
                          className={classes.smContentContainer}
                        >
                          <Grid
                            item
                            style={{ width: "-webkit-fill-available" }}
                          >
                            <E_Links
                              keyWord={keyWord}
                              searchLinksData={searchLinksData}
                            />
                          </Grid>
                        </Grid>
                      )
                    )}
                  </>
                )}
              </>
            )
          )}
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Grid
            container
            ref={containerRef}
            className={classes.contentContainer}
            style={{width:isTabletOrMobile?'100%':'110%'}}
          >
            <Grid item xs={12}>
              <SearchBar
                callSearchApi={callSearchApi}
                totalSearch={totalSearch}
                getDefaultSearch={getDefaultSearch}
              />
              {!noData && !loading && !keyWord ? (
                <>
                  <TabSection
                    selectedTab={selectedTab}
                    handleChange={handleChange}
                    searchAnnData={searchAnnData}
                    searchFAQData={searchFAQData}
                    searchLinksData={searchLinksData}
                    keyWord={keyWord}
                  />
                  {selectedTab === 0 && <EContent />}
                  {selectedTab === 1 && <E_Faqs />}
                  {selectedTab === 2 && <E_Announcements />}
                  {selectedTab === 3 && <E_Links />}
                </>
              ) : keyWord && loading === true ? (
                <Skeleton variant="text"></Skeleton>
              ) : (
                keyWord &&
                searchFAQData?.length === 0 &&
                searchAnnData?.length === 0 &&
                searchLinksData?.length === 0 && <SearchNoResult />
              )}
              {keyWord && (
                <>
                  <TabSection
                    selectedTab={selectedTab}
                    handleChange={handleChange}
                    searchAnnData={searchAnnData}
                    searchFAQData={searchFAQData}
                    searchLinksData={searchLinksData}
                    keyWord={keyWord}
                  />
                  {selectedTab === 0 && searchFAQData?.length > 0 && (
                    <E_Faqs keyWord={keyWord} searchFAQData={searchFAQData} />
                  )}
                  {selectedTab === 1 && searchAnnData?.length > 0 && (
                    <E_Announcements
                      keyWord={keyWord}
                      searchAnnData={searchAnnData}
                    />
                  )}
                  {selectedTab === 2 && searchLinksData?.length > 0 && (
                    <E_Links
                      keyWord={keyWord}
                      searchLinksData={searchLinksData}
                    />
                  )}
                </>
              )}{" "}
            </Grid>
          </Grid>
        </React.Fragment>
      )}
    </>
  );
}
export const TabSection = (props) => {
  const { t, ready: labelReady } = useTranslation('label-E_AUTH_LOGIN');
  const classes = useStyles();
  const isTab = useMediaQuery({ maxWidth: 830 });
  const tabs = !props.keyWord
    ? [
      { label: "E_AUTH_LOGIN_TAB_1_TEXT", value: 0 },
      { label: "E_AUTH_LOGIN_TAB_3_TEXT", value: 1 },
      { label: "E_AUTH_LOGIN_TAB_2_TEXT", value: 2 },
      { label: "E_AUTH_LOGIN_TAB_4_TEXT", value: 3 },
    ]
    : props?.searchFAQData?.length > 0 &&
      props?.searchAnnData?.length > 0 &&
      props?.searchLinksData?.length > 0
      ? [
        { label: "E_AUTH_LOGIN_TAB_3_TEXT", value: 0 },
        {
          label: "E_AUTH_LOGIN_TAB_2_TEXT",
          value: 1,
        },
        { label: "E_AUTH_LOGIN_TAB_4_TEXT", value: 2 },
      ]
      : props.searchFAQData?.length > 0 && props.searchAnnData?.length > 0
        ? [
          { label: "E_AUTH_LOGIN_TAB_3_TEXT", value: 0 },
          {
            label: "E_AUTH_LOGIN_TAB_2_TEXT",
            value: 1,
          },
        ]
        : props.searchFAQData?.length > 0 && props?.searchLinksData.length > 0
          ? [
            {
              label: "E_AUTH_LOGIN_TAB_3_TEXT",
              value: 0,
            },
            {
              label: "E_AUTH_LOGIN_TAB_4_TEXT",
              value: 2,
            },
          ]
          : props.searchAnnData?.length > 0 && props?.searchLinksData?.length > 0
            ? [
              { label: "E_AUTH_LOGIN_TAB_2_TEXT", value: 1 },
              {
                label: "E_AUTH_LOGIN_TAB_4_TEXT",
                value: 2,
              },
            ]
            : props.searchFAQData?.length > 0
              ? [{ label: "E_AUTH_LOGIN_TAB_3_TEXT", value: 0 }]
              : props.searchAnnData?.length > 0
                ? [{ label: "E_AUTH_LOGIN_TAB_2_TEXT", value: 1 }]
                : props.searchLinksData?.length > 0 && [
                  {
                    label: "E_AUTH_LOGIN_TAB_4_TEXT",
                    value: 2,
                  },
                ];
  return (
    <>
      {props?.keyWord &&
        props?.searchFAQData?.length === 0 &&
        props?.searchAnnData?.length === 0 &&
        props?.searchLinksData?.length === 0 ? null : (
        <Tabs
          indicatorColor=""
          variant="scrollable"
          value={props.selectedTab}
          onChange={props.handleChange}
          className={classes.baseTabStyles}
          scrollButtons={isTab ?"on":null}
          allowScrollButtonsMobile
        >
          {tabs &&
            tabs.map((tab, index) => {
              return (
                <Tab
                  key={index}
                  value = {tab.value}
                  className={[
                    props.selectedTab == tab.value
                      ? classes.selectedTab
                      : classes.unSelctedTab,
                    classes.tabStyles,
                  ]}
                  label={labelReady ? t(tab.label) : ''}
                />
              );
            })}
        </Tabs>
      )}
    </>
  );
};
export default EContentSection;
